module.exports = __webpack_public_path__ + "static/media/lacchain-org.ccb5e8e6.png";